import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { favouriteIconAnimationEnd } from "@/redux/actions/wishlistAction";

import FavouriteIcon from "@/components/common/FavouriteIcon";

import styles from "../Header.module.scss";
import mobStyles from "../NavMenu/MobMenu/MobMenu.module.scss";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

export default function Wishlist({isSuper,className, isPWA}) {
  const dispatch = useDispatch();

  const playFavouriteIconAnimation = useSelector(
    (state) => state.wishlist.play_favourite_icon_animation
  );

  const wishlist = useSelector((state) => state.wishlist.wishlist);

  const [numWishlistedItems, setNumWishlistedItems] = useState(0);
  const isMobile = useMediaQuery("(max-width: 767px)");

  useEffect(() => {
    setNumWishlistedItems(wishlist?.length);
  }, [wishlist]);

  let customClass = "";

  if (playFavouriteIconAnimation) {
    // Add favourites animation
    customClass = "filled";
  }

  const isFilled = numWishlistedItems > 0 ? true : false;

  return (
    <>
      <FavouriteIcon
        isFilled={isFilled}
        animationEndHandler={() => dispatch(favouriteIconAnimationEnd())}
        className={isMobile ? `ga_wishlist_icon_click ${customClass}` : `${customClass} ${className}`}
        width={20}
        height={20}
        isSuper={isSuper}
        isPWA={isPWA}
      />
      {isFilled && (
        <span
          className={`xxx-small italic fav-count bg-mink ${styles["fav-count"]} ${mobStyles["fav-count"]}`}
        >
          {numWishlistedItems}
        </span>
      )}
    </>
  );
}
